<template>
  <div class="move_in">
    <nav class="inav1 clearFix">
      <ul>
        <li>
          <a href="/">
            <span>网站首页</span>
          </a>
        </li>

        <li>
          <a href="/about">关于我们</a>
        </li>

        <li>
          <a href="/team">师资力量</a>
        </li>

        <li>
          <a href="/zhishi">培训知识</a>
        </li>

        <li>
          <a href="/course">全部课程</a>
        </li>

        <li>
          <a href="/xueyuan">客户案例</a>
        </li>

        <li>
          <a href="/news">新闻资讯</a>
        </li>

        <li>
          <a href="/contact">联系我们</a>
        </li>
      </ul>
    </nav>
    <div id="search" class="clearFix">
      <div class="telx fl" ig-phone>{{ data.tel }}</div>
      <div class="search_form fr">
        <form action="javascript:;" method="get">
          <input
            class="stxt fl"
            type="text"
            placeholder="请输入关键字"
            maxlength="10"
            id="keyword"
            name="keyword"
            v-model="searchQuery"
          />
          
          <el-button
            icon="el-icon-search"
            circle
            id="submit"
            class="sbtn fl"
            @click="handleSearch"
          ></el-button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import method from "@/utils/Untitl.js";
export default {
  props: {
    data: {
      default: () => {},
    },
  },
  data() {
    return {
      searchQuery: "",
    };
  },
  mounted() {},
  methods: {
    // 搜索
    handleSearch() {
      this.$router
        .push({
          path: "/course/course_in",
          query: { name: this.searchQuery },
        })
        .catch((err) => {
          // 只忽略“重复导航”错误，其他错误继续抛出
          if (err.name !== "NavigationDuplicated") throw err;
        });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/move/move_in.scss";
</style>
